import { render, staticRenderFns } from "./inviteVIPApply.vue?vue&type=template&id=774aa2b4&"
import script from "./inviteVIPApply.vue?vue&type=script&lang=js&"
export * from "./inviteVIPApply.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports